import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a34b438")

_pushScopeId("data-v-0a34b438")
const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
    /*#__PURE__*/_createVNode("ul", {
      class: "nav nav-pills justify-content-center",
      id: "myTab",
      role: "tablist"
    }, [
      /*#__PURE__*/_createVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createVNode("button", {
          class: "nav-link active",
          id: "datos-generales-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#datos-generales",
          type: "button",
          role: "tab",
          "aria-controls": "datos-generales",
          "aria-selected": "true"
        }, " Datos generales ")
      ]),
      /*#__PURE__*/_createVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createVNode("button", {
          class: "nav-link",
          id: "centro-costo-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#centro-costo",
          type: "button",
          role: "tab",
          "aria-controls": "centro-costo",
          "aria-selected": "false"
        }, " Centro de Costo ")
      ])
    ])
  ])
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "datos-generales",
  role: "tabpanel",
  "aria-labelledby": "datos-generales-tab"
}
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "centro-costo",
  role: "tabpanel",
  "aria-labelledby": "centro-costo-tab"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_datos_generales = _resolveComponent("datos-generales")
  const _component_centro_costo = _resolveComponent("centro-costo")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_datos_generales, {
              montoTotalRP: _ctx.sumaTotalRP,
              ref: "datosGenerales",
              "centro-costos": "$refs.centroCosto",
              plantilla: _ctx.plantilla
            }, null, 8, ["montoTotalRP", "plantilla"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_centro_costo, {
              onSumaTotal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sumaTotalRP = $event)),
              ref: "centroCosto"
            }, null, 512)
          ])
        ])
      ])
    ])
  ]))
})